<template>
  <div class="clause-popup" v-if="props.isShowClausePopup" @click="close">
    <div class="clause-content-box fadeIn" @click.stop>
      <a class="close-btn" @click="close"></a>
      <div class="content">用户隐私政策</div>
      <div>
        <p>
          【安永(中国)企业咨询有限公司】（以下简称“<b>安永</b>”）非常重视用户的隐私和个人信息保护。您在使用我们的服务时，我们可能会收集和使用您的相关信息。
        </p>
        <p>
          本《隐私政策》旨在向您说明：我们会收集您的哪些个人信息，如何处理这些个人信息，以及我们为您提供的行使您的权利的方式。我们也希望本政策可以帮助您决定是否向我们提供您的个人信息。
        </p>
        <p><b>我们收集哪些个人信息</b></p>
        <p>
          为了向您提供【 短信验证登入、历史记录、收藏、用户反馈
          】服务，您向安永提供或允许安永收集为提供服务所必需的个人信息
          如下（敬请知悉，没有这些信息安永将无法提供服务）：
        </p>
        <p>【电话号码、文章历史记录、文章收藏】</p>
        <p>共计【 3 】类个人信息</p>
        <p>
          除必需的个人信息外，您可自主选择向安永提供或允许安永收集下列个人信息，这些信息对改善服务质量等至关重要：
        </p>
        <p>【联系邮箱】</p>
        <p>共计【 1 】类个人信息</p>
        <p><b>个人信息的处理目的、处理方式及保存期限</b></p>
        <p>安永出于以下目的及方式处理您的个人信息：</p>
        <ol>
          <li>登入平台时需要通过电话号码接收随机短信验证码。</li>
          <li>查阅文章后记录您的查阅历史方便后续查看。</li>
          <li>针对喜欢的文章可以收藏方便随时查看。</li>
          <li>
            会为便于我们及时回复您提交的问题和建议，因此需要您在平台提交用户反馈时填写告知您的电话号码。
          </li>
        </ol>
        <p>
          安永将按照所提供服务的性质需要保存您的个人信息。在保存期限结束时，您的个人信息将被删除。但是，在服务终止后，安永将根据适用的法律、专业标准以及内部档案要求保留与个人信息相关的必要文件。
        </p>
        <p><b>明确同意处理敏感个人信息</b></p>
        <p>
          您特此授权安永处理敏感个人信息
          ，包括但不限于：【电话号码、文章历史记录、文章收藏】。这些敏感个人信息是安永提供【
          登入系统、历史记录、收藏、用户意见反馈
          】服务所必须的，安永处理这些敏感个人信息，不会对您的个人权益造成影响
          。
        </p>
        <p><b>明确同意向其他数据处理者提供个人信息</b></p>
        <p>
          安永将需要向【
          阿里云平台】提供您的个人信息【电话号码】，用于【登入时随机验证码短信发送】。
        </p>
        <p>您确认并同意安永按照本条所述向这些其他数据处理者提供个人信息。</p>
        <p><b>您的权利 </b></p>
        <p>
          除法律法规规定的例外情况，您可以向安永提出对您的个人信息行使查阅、复制、转移、更正、补充、删除及处理规则解释说明等权利。
        </p>
        <p><b>信息安全</b></p>
        <p>
          我们高度重视并承诺保护您的个人信息。我们会采取符合业界标准、合理可行的安全防护措施来保护您的个人信息以防止您的个人信息在未经授权的情况下被修改、被访问、被披露、被使用或被删除。
        </p>
        <p>
          如果发生信息安全事件，我们会按照法律法规的要求，采取合适、必要的处置措施。
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(["isShowClausePopup"]);
const emit = defineEmits(["update:isShowClausePopup"]);

const close = () => {
  emit("update:isShowClausePopup", false);
};
</script>

<style lang="less" scoped>
.clause-popup {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  padding: 20px;
  .clause-content-box {
    overflow-y: auto;
    position: absolute;
    width: 80%;
    height: 90%;
    background: #ffffff;
    left: 10%;
    top: 5%;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0px 3px 10px 0px rgba(50, 50, 50, 0.03);
    .close-btn {
      width: 25px;
      height: 25px;
      display: block;
      position: absolute;
      top: 20px;
      right: 20px;
      background: url("@/assets/images/close.png") no-repeat center center;
      background-size: cover;
      cursor: pointer;
    }
  }
}
</style>